module.exports = __webpack_public_path__ + "static/fonts/ef-picto.0dcf414.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ef-picto.eot?g697my
// module id = 236
// module chunks = 42